import { apiClientV2 } from '@/services/rest-api/apiClient'

const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

export const uploadFile = async (data) => {
  const formData = new FormData()
  for (const [key, value] of Object.entries(data)) {
    formData.append(key, value)
  }

  const res = await apiClientV2.put('/fleet-task/import/file', formData, {
    method: 'PUT',
    baseURL,
    headers: { 'Content-Type': 'multipart/form-data' },
  })

  return res?.data
}

export const createFleetTask = async (data) => {
  const res = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/fleet-task/import',
    data,
  })

  return res?.data
}

export const getDetail = async (id) => {
  const res = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/fleet-task/import/${id}`,
  })

  return res?.data
}

export const getImportResultFleetTask = async (importId, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam.sorts?.length > 0 ? queryParam.sorts : undefined,
    format: queryParam.format,
    resource: queryParam.resource,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/fleet-task/import/${importId}/result`,
    params: params,
  })

  return response?.data
}
